import { render, staticRenderFns } from "./qyzzylb.vue?vue&type=template&id=6545261e&scoped=true"
import script from "./qyzzylb.vue?vue&type=script&lang=js"
export * from "./qyzzylb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6545261e",
  null
  
)

export default component.exports